import type { FilteredProduct } from '@/api';
import type { MedicationPadItemType } from '@/components/PatientPageV2/components/PrescriptionPad';
import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';
import { createReissuedMedication } from '../utils/createReissuedMedication';

export const addReissuedMedicationToPrescriptionPad: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (
    availableMedications: FilteredProduct[],
    reissuedMedication: MedicationPadItemType,
    flags: {
      ffPatPrescriptionDosageMinLengthValidation: boolean;
      ffPatPrefillDosage: boolean;
    }
  ) => void
> = (set) => (availableMedications, reissuedMedication, flags) =>
  set(
    (state: PrescriptionAssistantSliceType) => {
      const existingMedicationPadItems = state.prescriptionAssistant.prescriptionPad.medicationPadItems.filter(
        (item) => !!item?.medicationPadItem
      );
      const previouslyPrescribedItem = state.prescriptionAssistant.prescriptionHistory.previousItems.find(
        (item) => item.id === reissuedMedication.medicationPadItem?.productId
      );

      const newReissuedMedication = createReissuedMedication(
        availableMedications,
        reissuedMedication,
        previouslyPrescribedItem,
        flags
      );

      if (!newReissuedMedication) {
        return;
      }

      const updatedPadMedications = [newReissuedMedication, ...existingMedicationPadItems];
      state.prescriptionAssistant.prescriptionPad.medicationPadItems = updatedPadMedications;
    },
    false,
    'prescriptionPad/addReissuedMedication'
  );
